import { DomainIDs } from 'common/constants/enums';

import { GlobalState } from '../store/initialState';

export const getScreenReference = (state: GlobalState): string | undefined =>
  state[DomainIDs.DEBUG]?.screenReference;
